import React, { useRef, useEffect, useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaPaperPlane } from 'react-icons/fa';
import { GiCoalPile } from 'react-icons/gi';
import './Contact.css';

const contactInfo = [
  {
    icon: <FaMapMarkerAlt />,
    title: 'Our Location',
    lines: ['10 Sean Costello Street', 'Irishtown, Athlone', 'Co. Westmeath, Ireland'],
  },
  {
    icon: <FaPhone />,
    title: 'Phone',
    lines: ['+353 90 645 0000'],
  },
  {
    icon: <FaEnvelope />,
    title: 'Email',
    lines: ['info@kingkebab.ie', 'orders@kingkebab.ie'],
  },
  {
    icon: <FaClock />,
    title: 'Hours',
    lines: ['Mon–Sun: Open from 4:00 PM'],
  },
];

const Contact = () => {
  const sectionRef = useRef(null);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('in-view')),
      { threshold: 0.1 }
    );
    sectionRef.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1200));
    setLoading(false);
    setSent(true);
    setTimeout(() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }, 5000);
  };

  return (
    <section id="contact" className="contact section-padding" ref={sectionRef}>
      <div className="contact-bg" />

      <div className="container">
        {/* Header */}
        <div className="section-header reveal">
          <span className="section-tag">Get in Touch</span>
          <div className="gold-line"><div className="gold-diamond" /></div>
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle" style={{ marginTop: '16px' }}>
            We'd love to hear from you — reach out for enquiries, events, or a warm welcome
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="contact-info-grid reveal">
          {contactInfo.map((item, i) => (
            <div className="contact-info-card" key={i}>
              <div className="ci-icon">{item.icon}</div>
              <div className="ci-body">
                <h4 className="ci-title">{item.title}</h4>
                {item.lines.map((line, j) => (
                  <p className="ci-line" key={j}>{line}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Contact Form + Map */}
        <div className="contact-bottom-grid">
          {/* Form */}
          <div className="contact-form-wrap reveal reveal-left">
            <h3 className="contact-form-title">Send a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit} id="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="contact-name">Full Name</label>
                  <input id="contact-name" type="text" name="name" className="form-input"
                    placeholder="Your name" value={form.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="contact-email">Email</label>
                  <input id="contact-email" type="email" name="email" className="form-input"
                    placeholder="your@email.com" value={form.email} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="contact-subject">Subject</label>
                <input id="contact-subject" type="text" name="subject" className="form-input"
                  placeholder="Enquiry, Private Dining, Events..." value={form.subject} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="contact-message">Message</label>
                <textarea id="contact-message" name="message" className="form-input form-textarea"
                  placeholder="Your message..." rows={5} value={form.message} onChange={handleChange} required />
              </div>

              <button
                type="submit"
                className={`btn-primary contact-submit ${loading ? 'loading' : ''} ${sent ? 'sent' : ''}`}
                disabled={loading || sent}
                id="contact-submit-btn"
              >
                {sent ? (
                  <><GiCoalPile /><span>Message Sent!</span></>
                ) : loading ? (
                  <><span className="spinner" /><span>Sending...</span></>
                ) : (
                  <><FaPaperPlane /><span>Send Message</span></>
                )}
              </button>
            </form>
          </div>

          {/* Map Placeholder */}
          <div className="contact-map reveal reveal-right">
            <div className="map-placeholder">
              <div className="map-grid" />
              <div className="map-center">
                <div className="map-pin-wrap">
                  <div className="map-pin-ring" />
                  <FaMapMarkerAlt className="map-pin-icon" />
                </div>
                <div className="map-label">
                  <span className="map-name">King Kebab</span>
                  <span className="map-address">10 Sean Costello St, Athlone</span>
                </div>
              </div>
              <div className="map-overlay-text">Interactive Map Coming Soon</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
